

import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import DeviceList from '../../components/device/DeviceList'
import Footer from '../../components/common/Footer'


export default function DeviceListPage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <DeviceList />
            <Footer/>
        </>
    )
}